import ItemDetailDialog from '../ItemDetailDialog.vue';

export default {
    components: { ItemDetailDialog },
    data() {
        return {
            itemDetailDialog: {
                isInsert: false,
                index: -1,
                visible: false,
                purpose: null,
                data: null,
                isTop: undefined,
            },
            itemSettingAccoutingMapping: {
                invoiceSettings: ['revSettings'], // 4
                payoutSettings: ['assetsSettings', 'costSettings', 'oeSettings'], // 1, 5, 6,
                cInSettings: ['norSettings'], // 7
                cOutSettings: ['oeSettings', 'noeSettings'], // 6, 8,
                cInElseSettings: ['assetsSettings', 'liabilitiesSettings', 'shareholderSettings'], // 1, 2, 3
                cOutElseSettings: ['assetsSettings', 'liabilitiesSettings', 'shareholderSettings', 'taxSettings'], // 1, 2, 3, 9
            },
            accoutingSettings: {
                // 會計科目列表
                assetsSettings: [], // 1
                liabilitiesSettings: [], // 2
                shareholderSettings: [], // 3
                revSettings: [], // 4
                costSettings: [], // 5
                oeSettings: [], // 6
                norSettings: [], // 7
                noeSettings: [], // 8
                taxSettings: [], // 9
            },
        };
    },
    methods: {
        async fetchAccountingOptions() {
            const resp = await this.$api({
                url: 'Tool/GetAccountingSettings',
                method: 'GET',
            });
            if (resp) {
                this.accoutingSettings.assetsSettings = resp.data.assetsSettings; // 1
                this.accoutingSettings.liabilitiesSettings = resp.data.liabilitiesSettings; // 2
                this.accoutingSettings.shareholderSettings = resp.data.shareholderSettings; // 3
                this.accoutingSettings.revSettings = resp.data.revSettings; // 4
                this.accoutingSettings.costSettings = resp.data.costSettings; // 5
                this.accoutingSettings.oeSettings = resp.data.oeSettings; // 6
                this.accoutingSettings.norSettings = resp.data.norSettings; // 7
                this.accoutingSettings.noeSettings = resp.data.noeSettings; // 8
                this.accoutingSettings.taxSettings = resp.data.taxSettings; // 9
            }
        },
        onItemDialogAdd(data) {
            const DATA = {
                accnam: data.accnam,
                accno: data.accno,
                accsno: data.accsno,
                grP_MEM: data.grP_MEM,
                iteM_NAM: data.iteM_NAM,
                suggestedAccItems: data.suggestedAccItems,
            };

            if (this.itemDetailDialog.isInsert) this.activeGroup.childSettings.splice(0, 0, DATA);
            else this.activeGroup.childSettings.push(DATA);

            this.onSave();
        },
        onItemDialogUpdate(data) {
            const FOUND = this.activeGroup.childSettings[this.itemDetailDialog.index];

            FOUND.accnam = data.accnam;
            FOUND.accno = data.accno;
            FOUND.accsno = data.accsno;
            FOUND.grP_MEM = data.grP_MEM;
            FOUND.iteM_NAM = data.iteM_NAM;
            FOUND.suggestedAccItems = data.suggestedAccItems;
            this.onSave();
        },
        onItemDialogDelete() {
            this.activeGroup.childSettings.splice(this.itemDetailDialog.index, 1);
            this.onSave();
        },
        onItemDialogClose() {
            this.itemDetailDialog.visible = false;
        },
        filterdAccountingOption(activeGroupName) {
            const options = [];

            // 用收支項目分類取得對應的會計科目分類選項
            const availableCategories = this.itemSettingAccoutingMapping[activeGroupName];
            if (!availableCategories) return [];

            // 把有效分類的會計項目 merge 成一維陣列
            availableCategories.forEach((categoryName) => {
                const accountingItems = this.accoutingSettings[categoryName];
                accountingItems.forEach((accItem) => {
                    // 轉換為 select option 格式
                    options.push({
                        accno: accItem.accno,
                        accnam: accItem.accnam,
                        label: `${accItem.accno} - ${accItem.accnam}`,
                        key: accItem.sno,
                        value: accItem.sno,
                    });
                });
            });
            return options;
        },
    },
};
